import React from 'react'
import Image from 'gatsby-image'
import styled from '@emotion/styled'
import { Global, css } from '@emotion/core'

export const breakpoints = {
  s: 576,
  m: 768,
  l: 992,
  xl: 1200,
}

export const GlobalStyle = props => (
  <Global
    {...props}
    styles={css`
      body {
        margin: 0;
      }
      html {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
          'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
          'Helvetica Neue', sans-serif;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;

        --black: #000;
        --white: #fff;

        --gray-100: #f7fafc;
        --gray-200: #edf2f7;
        --gray-300: #e2e8f0;
        --gray-400: #cbd5e0;
        --gray-500: #a0aec0;
        --gray-600: #718096;
        --gray-700: #4a5568;
        --gray-800: #2d3748;
        --gray-900: #1a202c;

        --blue-100: #ebf8ff;
        --blue-200: #bee3f8;
        --blue-300: #90cdf4;
        --blue-400: #63b3ed;
        --blue-500: #4299e1;

        --red-100: #fed7d7;
        --red-200: #feb2b2;
        --red-300: #fc8181;
        --red-400: #f56565;
        --red-500: #e53e3e;

        --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
          0 10px 10px -5px rgba(0, 0, 0, 0.04);
      }
      * {
        box-sizing: border-box;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      .shopify h1,
      .shopify h2,
      .shopify h3 {
        margin: 0 0 0.2rem;
        font-size: 0.9rem;
      }

      .shopify p {
        margin: 0;
        font-size: 0.8rem;
      }
    `}
  />
)

export const Img = styled(Image)`
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
`

export const Container = styled.div`
  margin: 0 auto;
  padding: 1.45rem 0.5rem 0;
  max-width: 960px;
`

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2rem 1fr;
  grid-template-rows: 1auto;
  grid-template-areas: 'left . right';

  @media (max-width: ${breakpoints.l}px) {
    display: block;
  }
`

export const GridLeft = styled.div`
  grid-area: left;
`

export const GridRight = styled.div`
  grid-area: right;
`

export const MainContent = styled.main`
  margin-top: 80px;
  margin-bottom: 40px;

  @media (max-width: ${breakpoints.l}px) {
    margin-top: 40px;
    margin-bottom: 20px;
  }
`

export const FormControl = styled.div`
  display: block;
  margin: 1rem 0;
`

export const Input = styled.input`
  border-radius: 0px;
  height: 3.5rem;
  height: 45px;
  color: var(--black);
  margin: 0;
  padding: 0.5rem 1rem;
  position: relative;
  z-index: 1;
  font-size: 1rem;
  transition: border-color 200ms cubic-bezier(0.19, 1, 0.22, 1);
  border: 1px solid var(--gray-400);
  width: 100%;

  &:focus {
    border-radius: 0px !important;
    border: 1px solid var(--black);
    outline: none;
  }
`

export const Label = styled.label`
  font-size: 1rem;
  display: block;
  margin-bottom: 0.2rem;
`

export const Title = styled.h1`
  font-size: 1.4rem;

  @media (min-width: ${breakpoints.m}px) {
    text-align: left;
  }
`

export const Paragraph = styled.p`
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.25rem;
  text-rendering: optimizeLegibility;
`

export const DESKTOP = '@media screen and (min-width: 1136px)'
export const TABLET = '@media screen and (min-width: 600px)'
export const PHONE = '@media screen and (min-width: 320px)'
